import React from 'react'

import 'react-tooltip/dist/react-tooltip.css'

import * as S from './styles'

import { useNanoId } from '../../../hooks/useNanoId'
import { TooltipIcon } from '../TooltipIcon'

import type { TooltipWithIconProps } from './types'
import type { PropsWithChildren } from 'react'
import type { PlacesType } from 'react-tooltip'

export const TooltipWithIcon: React.FC<TooltipWithIconProps> = ({
  className,
  children,
  content,
  place,
  iconSvg,
  ...iconProps
}) => {
  const id = useNanoId()

  return (
    <>
      <TooltipIcon iconSvg={iconSvg} id={id} {...iconProps} />
      <S.Tooltip
        anchorId={id}
        content={content}
        place={place}
        className={className}
      >
        <S.TooltipChildren>{children}</S.TooltipChildren>
      </S.Tooltip>
    </>
  )
}

export const Tooltip = ({
  children,
  title,
  position,
}: PropsWithChildren<{ title: string; position?: PlacesType }>) => {
  const id = useNanoId()
  return (
    <>
      <div
        data-tooltip-id={`tooltip-${id}`}
        data-tooltip-content={title}
        data-tooltip-place={position || 'top'}
        data-tooltip-position-strategy="fixed"
      >
        {children}
      </div>
      <S.Tooltip id={`tooltip-${id}`} />
    </>
  )
}
